"use client";

import { Carousel } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import {
  andersen,
  dkb,
  engel,
  engelCommercial,
  evernest,
  fabio,
  iwa,
  kieplinski,
  sothebys,
} from "../../../../public/images/partner";

const partners = [
  { src: engel, alt: "Engel & Völkers AG" },
  { src: dkb, alt: "DKB Grund GmbH" },
  { src: evernest, alt: "Evernest Urban Real Estate" },
  {
    src: sothebys,
    alt: "Sothebys International Realty",
  },
  { src: engelCommercial, alt: "Engel & Völkers Commercial GmbH" },
  { src: kieplinski, alt: "Kielpinski & Co. Immobilien GmbH & Co. KG" },
  { src: iwa, alt: "I.W.A.-Koschella-Immobilien GmbH" },
  { src: andersen, alt: "Immobilien & Projektierung GmbH" },
  { src: fabio, alt: "Fabio Herrmann Immobilien" },
];

const Partners = () => {
  const t = useTranslations("common");

  return (
    <div className="flex w-full flex-col items-center justify-center gap-15">
      <Carousel
        items={partners.map((partner, i) => {
          return (
            <div
              key={i}
              className="gs--partner-carousel__logo flex h-full w-full items-center justify-center"
            >
              <Image width={200} src={partner.src} alt={partner.alt} />
            </div>
          );
        })}
      />

      <span className="s:text-4xl pl-10 text-center text-2xl font-black tracking-[0.35em] text-gray-200 uppercase md:text-6xl lg:text-8xl xl:text-9xl">
        {t("trust")}
      </span>
    </div>
  );
};

export default Partners;
